import script from "./register.vue?vue&type=script&setup=true&lang=ts"
export * from "./register.vue?vue&type=script&setup=true&lang=ts"

import "./register.less?vue&type=style&index=0&lang=less&external"

const __exports__ = script;

export default __exports__